import React from 'react';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import { Stack } from '@mui/material';
import { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import RightIconButton from '../antrag-components/RightIconButton';

// import schemas

const AntragRightSidebarBottomIcons: FC<{}> = () => {
	const { handlePrint } = useApplication();


	return (
		<>			
			<Stack direction={'row'} spacing={3} sx={{ mt: '2rem', justifyContent: 'space-between' }}>
				<div>
					<RightIconButton onClick={() => handlePrint()} icon={<PrintOutlinedIcon />} tooltipTitle='Drucken'></RightIconButton>
				</div>
			</Stack>
		</>
	);
};
export default AntragRightSidebarBottomIcons;
